module.exports = __webpack_public_path__ + "static/media/shutterstock_710155132.95214d3c.jpg";